/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlCheckBlocklistResponse
 */
export interface ControlCheckBlocklistResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlCheckBlocklistResponse
     */
    blocklisted: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlCheckBlocklistResponse
     */
    allowlisted: Array<string>;
}

/**
 * Check if a given object implements the ControlCheckBlocklistResponse interface.
 */
export function instanceOfControlCheckBlocklistResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "blocklisted" in value;
    isInstance = isInstance && "allowlisted" in value;

    return isInstance;
}

export function ControlCheckBlocklistResponseFromJSON(json: any): ControlCheckBlocklistResponse {
    return ControlCheckBlocklistResponseFromJSONTyped(json, false);
}

export function ControlCheckBlocklistResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlCheckBlocklistResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'blocklisted': json['blocklisted'],
        'allowlisted': json['allowlisted'],
    };
}

export function ControlCheckBlocklistResponseToJSON(value?: ControlCheckBlocklistResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'blocklisted': value.blocklisted,
        'allowlisted': value.allowlisted,
    };
}

